import KeyAccessInfo from './key_access_info';

export default KeyAccessInfo;
